import styled from "styled-components";

export const GeneralTemplate = styled.div`
  border-radius: 10px;
  padding: 20px;
  border-radius: 10px;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #EFEFF9;
  .template-header {
    display: flex;
    align-items: center;
    &__icon {
      color: #36369B;
      margin-left: 5px;
      font-size: 13px;
    }
    &__title{
      font-family: "Nunito Sans Light";
      color: #1F1F52;
      font-size: 20px;
    }
  }
  .template-content {
    display: flex;
    flex-direction: column;
  }
  .template-content-item {
    margin: 20px 20px 0 20px;
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      font-family: "Nunito Sans";
      font-size: 17px;
      &__icon-payload {
        margin-left: 10px;
        font-size: 14px;
        color: #0C0AA2;
      }
      &__text {
        color: #1F1F52;
        font-family: Nunito Sans;
        font-size: 14px;
        margin-right: 10px;
      }
      &__required {
        width: 7px;
        color: #FF5757;
      }
      &__icon {
        color: #1F1F52;
        font-size: 7px;
      }
    }
    .extra-data {
      font-size: 11px;
      color: var(--blue-color);
      font-weight: 900;
      text-align: right;
      margin-top: 5px;
    }
  }
`;

export const PopUpPayload = styled.div`
  background: ${(theme) => theme.primaryCardComment};
  background: var(--white);
  color: black !important;
  box-shadow: 0px 3px 6px ${({theme}) => theme.blackShadow}29;
  border-radius: 5px;
  font-size: 'Nunito';
  max-width: 300px;
  color: #3E3E5B !important;
  padding: 10px;
  font-size: 15px;
  font-family: 'Nunito Sans';
  p {
    color: #3E3E5B !important;
    font-size: 15px;
    font-family: 'Nunito Sans';
  }
`